// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FrontpageUI_wrapper__SbTyf {
  padding-bottom: 2rem;
}

/* Header area */

.FrontpageUI_headerActions__0ngja {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* Tabs override */

.FrontpageUI_tabsContainer__j2E9x .ant-tabs-nav {
  margin-bottom: 1.5rem;
}

.FrontpageUI_tabsContainer__j2E9x .ant-tabs-tab {
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 1.125rem;
  letter-spacing: 0.03em;
  padding: 0.5rem 1.25rem;
  text-transform: uppercase;
}

.FrontpageUI_tabsContainer__j2E9x .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--orange) !important;
}

.FrontpageUI_tabsContainer__j2E9x .ant-tabs-ink-bar {
  background: var(--orange);
  height: 0.1875rem !important;
}

.FrontpageUI_tabsContainer__j2E9x .ant-tabs-tab:hover .ant-tabs-tab-btn {
  color: var(--orange);
}

/* Tab extra content (new button) */

.FrontpageUI_newButton__NgFGd {
  border-color: var(--orange);
  color: var(--orange);
  font-weight: 600;
  font-size: 0.8125rem;
  border-radius: 0.375rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.FrontpageUI_newButton__NgFGd:hover,
.FrontpageUI_newButton__NgFGd:focus {
  border-color: var(--orange);
  color: #fff;
  background-color: var(--orange);
}

/* Table */

.FrontpageUI_banner__byzxr {
  width: 13rem;
  height: 5.5rem;
  background-position: center center;
  background-size: cover;
  border-radius: 0.5rem;
  overflow: hidden;
}

.FrontpageUI_banner__byzxr img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
}

/* Platform tags */

.FrontpageUI_tagWeb__dcDs5 {
  color: var(--orange);
  border-color: var(--orange);
  background-color: var(--offRed);
  border-radius: 0.625rem;
  font-weight: 500;
  font-size: 0.75rem;
}

.FrontpageUI_tagApp__4oKr3 {
  color: #1890ff;
  border-color: #1890ff;
  background-color: #e6f7ff;
  border-radius: 0.625rem;
  font-weight: 500;
  font-size: 0.75rem;
}

.FrontpageUI_tagKiosco__LfSy7 {
  color: #52c41a;
  border-color: #52c41a;
  background-color: #f6ffed;
  border-radius: 0.625rem;
  font-weight: 500;
  font-size: 0.75rem;
}

/* Action type tags */

.FrontpageUI_tagAction__Tov1g {
  border-radius: 0.625rem;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: capitalize;
}

/* Actions column */

.FrontpageUI_actions__dxD10 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}

.FrontpageUI_editBtn__clxmY {
  color: var(--orange) !important;
  border: none;
  box-shadow: none;
}

.FrontpageUI_editBtn__clxmY:hover {
  color: var(--orange) !important;
  background-color: var(--offRed) !important;
}

.FrontpageUI_deleteBtn__G-BFC {
  color: #ff4d4f !important;
  border: none;
  box-shadow: none;
}

.FrontpageUI_deleteBtn__G-BFC:hover {
  color: #ff4d4f !important;
  background-color: #fff1f0 !important;
}

/* Switch override */

.FrontpageUI_activeSwitch__TpB2D.ant-switch-checked {
  background-color: var(--orange);
}

/* Loader */

.FrontpageUI_loader__rYvBs {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  min-height: 15rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/frontpage/styles/FrontpageUI.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA,gBAAgB;;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;;AAClB;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mCAAmC;;AACnC;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;EACX,+BAA+B;AACjC;;AAEA,UAAU;;AACV;EACE,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,kBAAkB;;AAClB;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;;AACrB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,mBAAmB;;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,oBAAoB;;AACpB;EACE,+BAA+B;AACjC;;AAEA,WAAW;;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,iBAAiB;AACnB","sourcesContent":[".wrapper {\n  padding-bottom: 2rem;\n}\n\n/* Header area */\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n/* Tabs override */\n.tabsContainer :global(.ant-tabs-nav) {\n  margin-bottom: 1.5rem;\n}\n\n.tabsContainer :global(.ant-tabs-tab) {\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 1.125rem;\n  letter-spacing: 0.03em;\n  padding: 0.5rem 1.25rem;\n  text-transform: uppercase;\n}\n\n.tabsContainer :global(.ant-tabs-tab-active .ant-tabs-tab-btn) {\n  color: var(--orange) !important;\n}\n\n.tabsContainer :global(.ant-tabs-ink-bar) {\n  background: var(--orange);\n  height: 0.1875rem !important;\n}\n\n.tabsContainer :global(.ant-tabs-tab:hover .ant-tabs-tab-btn) {\n  color: var(--orange);\n}\n\n/* Tab extra content (new button) */\n.newButton {\n  border-color: var(--orange);\n  color: var(--orange);\n  font-weight: 600;\n  font-size: 0.8125rem;\n  border-radius: 0.375rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.newButton:hover,\n.newButton:focus {\n  border-color: var(--orange);\n  color: #fff;\n  background-color: var(--orange);\n}\n\n/* Table */\n.banner {\n  width: 13rem;\n  height: 5.5rem;\n  background-position: center center;\n  background-size: cover;\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n\n.banner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 0.5rem;\n}\n\n/* Platform tags */\n.tagWeb {\n  color: var(--orange);\n  border-color: var(--orange);\n  background-color: var(--offRed);\n  border-radius: 0.625rem;\n  font-weight: 500;\n  font-size: 0.75rem;\n}\n\n.tagApp {\n  color: #1890ff;\n  border-color: #1890ff;\n  background-color: #e6f7ff;\n  border-radius: 0.625rem;\n  font-weight: 500;\n  font-size: 0.75rem;\n}\n\n.tagKiosco {\n  color: #52c41a;\n  border-color: #52c41a;\n  background-color: #f6ffed;\n  border-radius: 0.625rem;\n  font-weight: 500;\n  font-size: 0.75rem;\n}\n\n/* Action type tags */\n.tagAction {\n  border-radius: 0.625rem;\n  font-weight: 500;\n  font-size: 0.75rem;\n  text-transform: capitalize;\n}\n\n/* Actions column */\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n}\n\n.editBtn {\n  color: var(--orange) !important;\n  border: none;\n  box-shadow: none;\n}\n\n.editBtn:hover {\n  color: var(--orange) !important;\n  background-color: var(--offRed) !important;\n}\n\n.deleteBtn {\n  color: #ff4d4f !important;\n  border: none;\n  box-shadow: none;\n}\n\n.deleteBtn:hover {\n  color: #ff4d4f !important;\n  background-color: #fff1f0 !important;\n}\n\n/* Switch override */\n.activeSwitch:global(.ant-switch-checked) {\n  background-color: var(--orange);\n}\n\n/* Loader */\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 15rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `FrontpageUI_wrapper__SbTyf`,
	"headerActions": `FrontpageUI_headerActions__0ngja`,
	"tabsContainer": `FrontpageUI_tabsContainer__j2E9x`,
	"newButton": `FrontpageUI_newButton__NgFGd`,
	"banner": `FrontpageUI_banner__byzxr`,
	"tagWeb": `FrontpageUI_tagWeb__dcDs5`,
	"tagApp": `FrontpageUI_tagApp__4oKr3`,
	"tagKiosco": `FrontpageUI_tagKiosco__LfSy7`,
	"tagAction": `FrontpageUI_tagAction__Tov1g`,
	"actions": `FrontpageUI_actions__dxD10`,
	"editBtn": `FrontpageUI_editBtn__clxmY`,
	"deleteBtn": `FrontpageUI_deleteBtn__G-BFC`,
	"activeSwitch": `FrontpageUI_activeSwitch__TpB2D`,
	"loader": `FrontpageUI_loader__rYvBs`
};
export default ___CSS_LOADER_EXPORT___;
